// extracted by mini-css-extract-plugin
export default {"page":"XwSIT6"};